import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faCheck } from "@fortawesome/free-solid-svg-icons";
import ModalForbiddenMedicineUpdate from './ModalForbiddenMedicineUpdate';
import AlertModal from '../../../../shared/components/Modal';

const ListForbiddenMedicineActions = ({ data, state }) => {
    const history = useHistory();
    const [openModal, setOpenModal] = React.useState(false);
    const [showDeleteModal, setDeleteModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);

    useEffect(() => {

    }, []);

    const openUpdateModal = () => {
        setOpenModal(true);
    }

    const closeModalDelete = () => {
        setDeleteModal(false);
    }

    const refresh = () => {
        let _url = "/clinical-studio/forbidden-medicines";
        if (window.location.pathname === process.env.PUBLIC_URL + _url) {
            history.replace(process.env.PUBLIC_URL );
            setTimeout(() => {
                history.push({
                    pathname: process.env.PUBLIC_URL + _url,
                    state: data.original.feasibility
                });
            }, 0);
        }
    }

    const deleteForbiddenMedicine = async () => {
        let dataForbiddenMedicine =
        {
            id_med_proh: parseInt(data.original.id_med_proh)
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}mediproh/delete`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataForbiddenMedicine)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                response.json();
            }
            else {
                setDeleteModal(false);
                setSuccessModal(false);
                setErrorModal(true);
            }
        }).then(data => {
            setDeleteModal(false);
            setSuccessModal(true);
            setErrorModal(false);
        }).catch(err => {
            setDeleteModal(false);
            setSuccessModal(false);
            setErrorModal(true);
        });
    }

    return (<Fragment>
        <td role="cell">
            <IconButton style={{ fontSize: '15px' }} onClick={() => openUpdateModal()}>
                <FontAwesomeIcon icon={faEdit} />
            </IconButton>

            <IconButton style={{ fontSize: '15px' }} onClick={() => setDeleteModal(true)}>
                <FontAwesomeIcon icon={faTrashAlt} />
            </IconButton>

            <ModalForbiddenMedicineUpdate
                ForbiddenMedicine={data.original}
                doCloseModalForbiddenMedicine={() => setOpenModal(false)}
                opened={openModal}
                feasibility={data.original.feasibility}
            />
        </td>

        <AlertModal
            color="warning"
            title="Esta seguro de eliminar este medicamento prohibido?"
            modal={showDeleteModal}
            onOk={() => deleteForbiddenMedicine()}
            toggle={() => closeModalDelete()}
        />

        <AlertModal
            color="success"
            title="Medicamento Prohibido eliminado correctamente"
            modal={successModal}
            onOk={() => refresh()}
            toggle={() => setSuccessModal(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error al eliminar el Medicamento Prohibido"
            modal={errorModal}
            onOk={() => setErrorModal(false)}
            toggle={() => setErrorModal(false)}
        />
    </Fragment>)
}

export default reduxForm({
    form: `modal-form`, // a unique identifier for this form
})(withTranslation('common')(ListForbiddenMedicineActions));